import { useTranslation } from 'next-i18next'
import { useTemplateCategories } from '../hooks/use-template-categories'
import { TemplatesFilterInterface } from '../types/templates-filter-interface'
import TemplatesCategoryItem from './templates-category-item'
import TemplatesCategorySelector from './templates-category-selector'
import TemplatesCategorySkeleton from './templates-category-skeleton'

interface TemplatesCategoriesProps {
  filter: TemplatesFilterInterface
  onChangeCategory: (category: number | null) => void
}

const TemplatesCategories = ({ filter, onChangeCategory }: TemplatesCategoriesProps) => {
  const { data: categories } = useTemplateCategories()
  const { t } = useTranslation()

  return categories ? (
    categories.length !== 0 ? (
      <>
        <div className={'row-start-2 hidden w-fit flex-col lg:flex'}>
          <TemplatesCategoryItem
            isSelected={!filter.category}
            onClick={() => onChangeCategory(null)}
          >
            {t('public.templates.categories.all_categories')}
          </TemplatesCategoryItem>
          {categories.map(category => (
            <TemplatesCategoryItem
              isSelected={filter.category === category.id}
              onClick={() => onChangeCategory(category.id)}
              key={category.id}
            >
              {category.name}
            </TemplatesCategoryItem>
          ))}
        </div>
        <TemplatesCategorySelector
          categories={categories}
          onChangeCategory={onChangeCategory}
          filter={filter}
        />
      </>
    ) : null
  ) : (
    <TemplatesCategorySkeleton />
  )
}

export default TemplatesCategories
